import { get } from 'miniruche/services/api';

export function fetchSale({ slug, saleId }) {
    return get(`miniruche/${slug}/sales/${saleId}`);
}
